import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {MyReferralsFlowEndPoints} from 'main/factories/usecases/endpoints';
import {GetReferralsList} from './referral-list';
import {RemoteGeReferralsList} from './remote-get-referral';

export const makeGetReferrals = (): GetReferralsList =>
	new RemoteGeReferralsList(
		makeBFFApiUrl(MyReferralsFlowEndPoints.referrals),
		makeAuthorizeHttpClientDecorator(),
	);
